import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import getters from './getters'
import classSotre from './modules/class'
import course from './modules/course'
import createPersistedState from 'vuex-persistedstate'
import cache from './modules/cache'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    tagsView,
    user,
    classSotre,
    course,
    cache
  },
  getters
})

export default store
